export const MESSAGE_HIGHLIGHT_MS = 1600;

const SCROLL_SETTLE_FALLBACK_MS = 400;

const MESSAGE_RENDER_TIMEOUT_MS = 1000;

export function waitForMessageElement(messageId: string): Promise<HTMLElement | null> {
    return new Promise((resolve) => {
        const deadline = performance.now() + MESSAGE_RENDER_TIMEOUT_MS;

        function poll() {
            const item = getMessageScrollerItem(messageId);

            if (item || performance.now() >= deadline) {
                resolve(item);
                return;
            }

            requestAnimationFrame(poll);
        }

        poll();
    });
}

export function waitForScrollerSettle(viewport: HTMLElement): Promise<void> {
    return new Promise((resolve) => {
        let settled = false;

        function finish() {
            if (settled) {
                return;
            }
            settled = true;
            viewport.removeEventListener("scrollend", finish);
            viewport.removeEventListener("scroll", onScroll);
            window.clearTimeout(fallbackId);
            window.clearTimeout(debounceId);
            resolve();
        }

        let debounceId = 0;
        function onScroll() {
            window.clearTimeout(debounceId);
            debounceId = window.setTimeout(finish, 80);
        }

        viewport.addEventListener("scrollend", finish);
        viewport.addEventListener("scroll", onScroll);
        const fallbackId = window.setTimeout(finish, SCROLL_SETTLE_FALLBACK_MS);
    });
}

export function getMessageScrollerItem(messageId: string): HTMLElement | null {
    const item = document.querySelector(`[data-message-id="${CSS.escape(messageId)}"]`);
    return item instanceof HTMLElement ? item : null;
}

export function getChatScrollerViewport(): HTMLElement | null {
    const viewport = document
        .querySelector("[data-message-id]")
        ?.closest('[role="region"]');
    return viewport instanceof HTMLElement ? viewport : null;
}

/** Prepend-safe origin marker: scrollTop shifts as older pages load, ids do not. */
export function getTopmostVisibleMessageId(viewport: HTMLElement): string | null {
    const viewportTop = viewport.getBoundingClientRect().top;

    for (const item of viewport.querySelectorAll("[data-message-id]")) {
        if (
            item instanceof HTMLElement &&
            item.getBoundingClientRect().bottom > viewportTop
        ) {
            return item.dataset.messageId ?? null;
        }
    }

    return null;
}

export function isMessageFullyInScrollerViewport(messageId: string): boolean {
    const item = getMessageScrollerItem(messageId);
    const viewport = item?.closest('[role="region"]');
    if (!item || !(viewport instanceof HTMLElement)) {
        return false;
    }

    const itemRect = item.getBoundingClientRect();
    const viewportRect = viewport.getBoundingClientRect();

    return itemRect.top >= viewportRect.top && itemRect.bottom <= viewportRect.bottom;
}
